import React from 'react'
import ReactDOM from 'react-dom'
import { parse } from 'qs'
import LearnMoreComponent from '../../components/learn-more/LearnMoreComponent'
import { getLocale } from '../../components/learn-more/utils'
import { setupSentry, reportError } from '../../sentry'

import getBaseUrl from '../../../utils/getBaseUrl/getBaseUrl'
import GkdAuthParams from '../../../types/GkdAuthParams'
import { MobileSDKProvider } from '../../../services/MobileSDKMessaging/MobileSDKMessagingContext'

const COMPONENT_ID = 'LEARN_MORE'
const CLOSE_MESSAGE = 'CLOSE'

const sendMessage = (integratorData: any, message: string) => {
  window.parent.postMessage(JSON.stringify({
    type: message,
    source: COMPONENT_ID,
    ...integratorData
  }), '*')
}

const urlParams = parse(window.location.search, { ignoreQueryPrefix: true })
const showButtons = urlParams.showButtons === 'true'
const showBackground = urlParams.showBackground === 'true'

// url params from web-sdk
const isWebSDK = urlParams.websdk === 'true'
const clientId = urlParams.clientId || ''
const legacyOSMClientId = urlParams.legacyOSMClientId || ''
const integratorOrigin = urlParams.integratorOrigin || ''
const accountId = urlParams.accountId || ''
const gkdAuthParams: GkdAuthParams = { clientId, integratorOrigin, accountId }
// end - url params from web-sdk

function App() {
  setupSentry()

  const [, token] = window.location.hash.split('#')
  let params
  try {
    params = JSON.parse(decodeURIComponent(window.atob(token)))
  } catch (error) {
    reportError({ token }, error)
  }
  const integratorData = params?.trackerParameters || ''
  const locale = getLocale(params)

  const onClose = () => {
    sendMessage(integratorData, CLOSE_MESSAGE)
  }

  const baseUrl = getBaseUrl(locale) || process.env.CMA_BASE_URL

  return (
    <MobileSDKProvider componentName={params.bespokeId}>
      <LearnMoreComponent
        focusTrapActive={isWebSDK}
        isWebSDK={isWebSDK}
        showBackground={showBackground}
        params={{
          ...params, locale, adServerUrl: baseUrl, token, legacyOSMClientId
        }}
        gkdAuthParams={gkdAuthParams}
        onClose={showButtons ? onClose : null}
      />
    </MobileSDKProvider>
  )
}

ReactDOM.render(
  <App />,
  document.getElementById('root')
)
